<template>
  <div class="mx-2">
    <v-card class="mt-2 page-card" elevation="0 pa-2">
      <v-row>
        <v-col cols="12">
          <v-alert
            v-model="cannotAvail"
            type="warning"
            icon="mdi-alert-circle-outline"
            dense
          >
            <p class="text-subtitle-2">
              This module is only available for employees whose employee status
              are plantilla or permanent.
            </p>
          </v-alert>

       <!-- <PerformanceEvaluationDataTable v-if="!cannotAvail" /> -->
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    // PerformanceEvaluationDataTable: () =>
    //   import("../../components/Utils/PerformanceEvaluationDataTable.vue"),
  },
  created() {
    // console.log("created");
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
      // location.reload();
    }
  },
  mounted() {
    this.getMyEmploymentStatus();
  },
  data: () => ({
    typeData: [],
    action: null,
    hasHead: false,
    cannotAvail: null,
  }),
  methods: {
    add() {
      this.typeData = [{ id: null }];
      this.action = "Add";
    },

    getMyEmploymentStatus() {
      this.axiosCall("/employee/getMyEmploymentStatus/", "GET").then((res) => {
        if (res) {
          if (
            res.data.id != 1 &&
            res.data.id != 2 &&
            res.data.id != 3 &&
            res.data.id != 6 &&
            res.data.id != 11
          ) {
            this.cannotAvail = true;
          } else {
            this.cannotAvail = false;
          }
        }
      });
    },
  },
};
</script>

<style></style>
